import React from 'react';
import clsx from 'clsx';
import { NameTextField } from '../../../../../../styling/Styles';

const AnnotationValueSelection = ({ annotationValue, setAnnotationValue,comp,attributeType }) => {
  
  const handleAnnotationValue = (val) => {
    setAnnotationValue(val.target.value);
  };

  // comp view... throws a lot of undefined error thus try and catch is appropriate
  let labelContent = '';
  if (attributeType === 'checkbox' || attributeType === 'radiobox') {
    try {
      labelContent = comp.view.$el[0].innerText;
    } catch (e) {
      labelContent = '';
    }
  }


  return(
    <div className={clsx('spacingTopDiv')} style={{display: 'flex', flexDirection: 'row'}}>
      <div> Value: <span style={{ display: 'inline-block', marginLeft: '8vw' }} /> </div>
      
      <NameTextField
        placeholder=" Value"
        onInput={(e) => handleAnnotationValue(e)}
        value={annotationValue}
        error={annotationValue !== labelContent}
        //  helperText={annotationValue !== labelContent ? `suggested label: '${labelContent}'` : null}
        style={{width: 'auto'}}
      />
      
    </div>
  )
};

export default AnnotationValueSelection;